import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../config";

//No se usan en este proyecto
export const saveToStorage = (key, value) => {
  // Convierte el objeto a string antes de encriptarlo
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
  localStorage.setItem(key, encrypted);
};

export const getFromStorage = (key) => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;

  try {
    // Desencripta y convierte la cadena a JSON
    const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted); // Convierte a un objeto JS
  } catch (error) {
    console.error("Error al desencriptar o parsear los datos:", error);
    return null; // Devuelve null si falla la desencriptación
  }
};
